/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationHierarchyFilterDto } from './locationHierarchyFilterDto';
import { GeoLocationEntity } from './geoLocationEntity';


export interface FindGroupsDto { 
    /**
     * radius = city + distance (default); hierarchy = containment
     */
    searchMode?: FindGroupsDto.SearchModeEnum;
    hierarchy?: LocationHierarchyFilterDto;
    location?: GeoLocationEntity;
    radiusMeter?: number;
    sportIds?: Array<string>;
    notJoined?: boolean;
    notFromMe?: boolean;
    handiFriendlyOnly?: boolean;
    accountId?: string;
}
export namespace FindGroupsDto {
    export type SearchModeEnum = 'radius' | 'hierarchy';
    export const SearchModeEnum = {
        Radius: 'radius' as SearchModeEnum,
        Hierarchy: 'hierarchy' as SearchModeEnum
    };
}


